import type {
  FormValues,
  SchemaBuilderExpressionVariableFormValue,
  UseSchemaBuilderExpressionFormProps,
} from "./schema-builder-expression.type";
import type { VariableNode } from "@stelar/expression-engine";

import { Form } from "antd";

import { getVariablesValuesWithExistingValues } from "./schema-builder-expression.helper";

export const useSchemaBuilderExpressionForm = ({
  name,
}: UseSchemaBuilderExpressionFormProps) => {
  const form = Form.useFormInstance<FormValues>();
  const formula = Form.useWatch([name, "formula"], form) ?? "";
  const variables = Form.useWatch([name, "variables"], form) ?? [];

  const setFormula = (value: string) => {
    form.setFieldValue([name, "formula"], value);
  };

  const setVariables = (value: SchemaBuilderExpressionVariableFormValue[]) => {
    form.setFieldValue([name, "variables"], value);
  };

  const updateVariables = (nodes: VariableNode[]) => {
    const newVariables = getVariablesValuesWithExistingValues(nodes, variables);
    setVariables(newVariables);
  };

  const isFieldTouched = (fieldName: "formula" | "variables") => {
    return form.isFieldTouched([name, fieldName]);
  };

  return {
    form,
    formula,
    setFormula,
    variables,
    setVariables,
    updateVariables,
    isFieldTouched,
  };
};
